// extracted by mini-css-extract-plugin
export default {"myPlan":"my-plan_myPlan__7IV30","title":"my-plan_title__xwPBs","itemsList":"my-plan_itemsList__LpBBM","container":"my-plan_container__lebDH","paragraph":"my-plan_paragraph__D6cPj"};